import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/core/api.service';
import { Contact } from '../models/contact.model';
import { Observable } from 'rxjs';
import { Category } from '../models/category.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(private api: ApiService) {}

  /** Get the categories of contact types  */
  public getCategories(): Observable<Category[]> {    
    return this.api.get<Category>('contactus/categories');
  }

  /** Send the message for the api to email */
  public async sendMessage(message: Contact) {
    return await this.api.post<Contact>('contactus/send', message).toPromise();
  }
}
